import { INSTRUMENT_INFO_PATH_PREFIX } from './constants'

export type InstrumentLinkFlow = 'instrument' | 'login' | 'consent' | 'onboarding'

export const INVALID_INSTRUMENT_LINK_MESSAGE =
  'Invalid or expired link. Please contact your administrator for a new link.'

export function instrumentInfoPath(instrumentId: string): string {
  return `${INSTRUMENT_INFO_PATH_PREFIX}/${instrumentId}/info`
}

/** Internal query that tells Survey Info to begin the response without another click. */
export const NON_SIGNUP_SURVEY_AUTOSTART_PARAM = 'start'

export function nonSignupSurveyEntryPath(instrumentId: string): string {
  return `${instrumentInfoPath(instrumentId)}?${NON_SIGNUP_SURVEY_AUTOSTART_PARAM}=1`
}

export function isNonSignupSurveyAutostart(search: string): boolean {
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search)
  return params.get(NON_SIGNUP_SURVEY_AUTOSTART_PARAM) === '1'
}

/** Post-login redirect target for instrument-link return visits. */
export function instrumentLinkLoginState(instrumentId: string) {
  return {
    from: {
      pathname: instrumentInfoPath(instrumentId),
    },
  }
}

/** After an existing-number check, sign in then claim the retained survey. */
export function pendingSurveyClaimLoginState() {
  return {
    from: {
      pathname: '/rewards',
      search: '?from=signup-survey',
    },
    pendingSurveyClaim: true,
  }
}

export function instrumentLinkReturnState(pathname: string, search: string) {
  return {
    from: {
      pathname,
      search: search || undefined,
    },
  }
}
